import PropTypes from 'prop-types';
import { SALE_PRICE_COLUMN } from '../../../constants/pricings';
import { PricingTableSalePrices } from './PricingTableSalePrices';
import { NO_VALUE_PLACEHOLDER } from '../../../constants/tables';

export function PricingTablePrices({ prices, currency, priceTypes }) {
  const hasSalePriceColumn = priceTypes.includes(SALE_PRICE_COLUMN);

  return (
    <>
      <td>{currency}</td>
      {priceTypes.map((priceType) => (
        <td key={priceType}>{prices[priceType] || NO_VALUE_PLACEHOLDER}</td>
      ))}
      {hasSalePriceColumn ? <PricingTableSalePrices prices={prices} /> : null}
    </>
  );
}

PricingTablePrices.propTypes = {
  prices: PropTypes.object.isRequired,
  currency: PropTypes.string.isRequired,
  priceTypes: PropTypes.array.isRequired,
};
